export default __webpack_public_path__ + "static/media/Cirka-Variable.06744734.ttf";